import { get } from "src/services/api";
import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { useQuery, useMutation } from "@tanstack/react-query";
import { sharePreview, getPreviewLink, getPreviewBranchDeployer, extendPreview, preparePreview } from "src/queries/services/preview";

export const useExternalPreview = (q) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.EXTERNAL_PREVIEW],
  queryFn: async () => await get({ endpoint: "/preview", params: { q } }),
  staleTime: Infinity,
  enabled: !!q
});

export const useExternalPreviewLink = ({ accountId, assistantId, branchName }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.EXTERNAL_PREVIEW_LINK, { accountId, assistantId, branchName }],
  queryFn: async () => await getPreviewLink({ accountId, assistantId, branchName }),
  enabled: !!accountId && !!assistantId,
  staleTime: Infinity
});

export const useMutateSharePreview = () => useMutation({
  mutationFn: sharePreview
});

export const usePreviewBranchDeployer = ({ accountId, assistantId, branchName, releaseName }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.PREVIEW_BRANCH_DEPLOYER, { accountId, assistantId, branchName, releaseName }],
  queryFn: async () => await getPreviewBranchDeployer({ accountId, assistantId, branchName, releaseName }),
  enabled: !!accountId && !!assistantId,
  staleTime: Infinity
});

export const useMutateExtendPreview = () => useMutation({
  mutationFn: extendPreview
});

export const useMutatePreparePreview = () => useMutation({
  mutationFn: preparePreview
});
